/* ChillyPup guide and policy page scripts, carried over from the Premium design for the old theme. */
/* Scroll flow: content eases into view as you scroll, with gentle parallax on key photos.
   Applies to the ChillyPup sections on every page. Dawn sections already have their own reveal.
   Nothing moves for visitors who have reduced motion switched on. */
(function(){
  'use strict';
  if (window.__cpFlow) return; window.__cpFlow = true;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;
  var GROUPS = [
    ['.cp-guides__head > *, .cp-tg__head > *, .cp-gallery__head > *, .cp-reviews__head > *, .cp-pair__head > *, .cp-sel__head > *', 0.08],
    ['.cp-guides__item, .cp-tg__item, .cp-gallery__item, .cp-pair__card, .cp-pair__plus, .cp-sel__grid > .cp-card, .cp-trust__item, .cp-cl__item', 0.07],
    ['.cp-story__content > *, .cp-guide__chapter > *, .cp-details__intro > *', 0.06],
    ['.cp-acc', 0.04],
    ['.cp-cl__feature, .cp-cl__grid-h, .cp-cl__chips, .cp-guides__note, .cp-gallery__foot, .cp-tg__closing, .cp-pair__offer, .cp-sel__foot, .cp-reviews__foot, .cp-story__visual', 0]
  ];
  function init(){
    var main = document.getElementById('MainContent') || document.body;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    GROUPS.forEach(function(g){
      main.querySelectorAll(g[0]).forEach(function(el){
        if (el.closest('.scroll-trigger, .product__info-container, .cp-flow-skip')) return;
        var i = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.classList.add('cp-rv');
        el.style.setProperty('--rv-d', Math.min(i * g[1], 0.5) + 's');
        io.observe(el);
      });
    });
    if (document.querySelector('[data-cp-noparallax]')) return;
    var px = [];
    main.querySelectorAll('.cp-hero__media img').forEach(function(el){ px.push({ el: el, box: el.parentNode, k: -0.06, s: 1.08 }); });
    main.querySelectorAll('.cp-story__media img').forEach(function(el){ px.push({ el: el, box: el.parentNode, k: -0.05, s: 1.1 }); });
    if (window.matchMedia('(min-width: 990px)').matches) {
      main.querySelectorAll('.cp-gallery__strip').forEach(function(strip){
        strip.querySelectorAll('.cp-gallery__fig').forEach(function(el, n){ px.push({ el: el, box: strip, k: (n % 2 ? -0.08 : 0.04), s: 1 }); });
      });
    }
    if (!px.length) return;
    px.forEach(function(p){ p.el.setAttribute('data-cp-px', ''); });
    var ticking = false;
    function run(){
      ticking = false;
      var vh = window.innerHeight;
      px.forEach(function(p){
        var r = p.box.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var y = (r.top + r.height / 2 - vh / 2) * p.k;
        p.el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)' + (p.s !== 1 ? ' scale(' + p.s + ')' : '');
      });
    }
    window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    window.addEventListener('resize', run);
    run();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Policy pages (shipping, returns, privacy, terms): rebuilt as a guide-style layout with a sticky
   "On this page" contents list, matching the dog owner's guide. The policy wording itself is untouched. */
(function(){
  'use strict';
  function init(){
    var box = document.querySelector('.shopify-policy__container');
    if (!box || box.dataset.cpPolicy) return;
    var body = box.querySelector('.shopify-policy__body .rte') || box.querySelector('.shopify-policy__body');
    if (!body) return;
    box.dataset.cpPolicy = '1';
    var path = location.pathname;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var NL = /^nl/i.test(document.documentElement.lang || '');
    var L = NL ? { help: 'Hulp &amp; info', toc: 'Op deze pagina', q: 'Nog een vraag?', small: 'We zijn een klein familiebedrijf en helpen je graag.', contact: 'Neem contact op', more: 'Meer hulp &amp; info', updated: 'Laatst bijgewerkt', other: 'Andere voorwaarden' } : { help: 'Help &amp; info', toc: 'On this page', q: 'Still have a question?', small: 'We’re a small, family-run team and always happy to help.', contact: 'Contact us', more: 'More help &amp; info', updated: 'Last updated', other: 'Other policies' };
    var NAMES = NL ? { 'refund-policy': 'Retouren en terugbetalingen', 'shipping-policy': 'Verzendinformatie', 'privacy-policy': 'Privacybeleid', 'terms-of-service': 'Algemene voorwaarden', 'contact-information': 'Contactgegevens', 'legal-notice': 'Juridische mededeling', 'subscription-policy': 'Abonnementsbeleid' } : { 'refund-policy': 'Returns and refunds', 'shipping-policy': 'Shipping information', 'privacy-policy': 'Privacy policy', 'terms-of-service': 'Terms of service', 'contact-information': 'Contact information', 'legal-notice': 'Legal notice', 'subscription-policy': 'Subscription policy' };
    var key = (path.match(/\/policies\/([^\/?#]+)/) || [])[1] || '';
    var titleEl = box.querySelector('.shopify-policy__title h1');
    var title = NAMES[key] || (titleEl ? titleEl.textContent.trim() : document.title);
    var updated = '';
    var heads = [];
    var n = 0;
    Array.prototype.slice.call(body.children).forEach(function(el){
      var tag = el.tagName, txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!txt) { if (tag === 'P') el.remove(); return; }
      if (/^(last updated|laatst bijgewerkt)/i.test(txt) && txt.length < 60) { updated = txt.replace(/^(last updated|laatst bijgewerkt):?\s*/i, ''); el.remove(); return; }
      var isHead = /^H[1-4]$/.test(tag);
      if (!isHead && tag === 'P' && el.children.length === 1 && /^(STRONG|B)$/.test(el.children[0].tagName) && el.children[0].textContent.trim() === txt && txt.length < 90) isHead = true;
      if (!isHead) return;
      if (tag === 'H1' || (/chillypup/i.test(txt) && /(policy|terms|notices)/i.test(txt) && heads.length === 0)) { el.remove(); return; }
      var prev = el.previousElementSibling;
      if (prev && prev.classList && (prev.classList.contains('cp-pol__h') || prev.classList.contains('cp-pol__sub'))) {
        var sub = document.createElement('h3');
        sub.className = 'cp-pol__sub';
        sub.textContent = txt.replace(/:$/, '');
        el.replaceWith(sub);
        return;
      }
      var h = document.createElement('h2');
      h.className = 'cp-pol__h';
      h.textContent = txt.replace(/:$/, '');
      h.id = 'section-' + (++n);
      el.replaceWith(h);
      heads.push(h);
    });
    var others = [['shipping-policy',NAMES['shipping-policy']],['refund-policy',NAMES['refund-policy']],['privacy-policy',NAMES['privacy-policy']],['terms-of-service',NAMES['terms-of-service']]];
    var wrap = document.createElement('div');
    wrap.className = 'cp-pol';
    var tocItems = heads.map(function(h, i){ return '<li><a href="#' + h.id + '"><span class="cp-pol__num">' + ('0' + (i + 1)).slice(-2) + '</span><span>' + h.textContent.replace(/[<>&]/g, '') + '</span></a></li>'; }).join('');
    var rel = others.filter(function(o){ return o[0] !== key; }).map(function(o){ return '<li><a class="cp-pol__chip" href="' + root + 'policies/' + o[0] + '">' + o[1] + '</a></li>'; }).join('');
    wrap.innerHTML =
      '<header class="cp-pol__hero"><p class="cp-eyebrow">' + L.help + '</p><h1 class="cp-display cp-pol__title"></h1>' + (updated ? '<p class="cp-pol__updated">' + L.updated + ' ' + updated.replace(/[<>&]/g, '') + '</p>' : '') + '</header>' +
      '<div class="cp-pol__grid">' +
        (heads.length > 1 ? '<aside class="cp-pol__side"><details class="cp-pol__toc" open><summary><span class="cp-eyebrow">' + L.toc + '</span><span class="cp-acc__icon" aria-hidden="true"></span></summary><ol class="cp-pol__list" role="list">' + tocItems + '</ol></details>' +
        '<div class="cp-pol__help"><p class="cp-pol__help-title">' + L.q + '</p><p>' + L.small + '</p><a class="cp-link" href="' + root + 'pages/contact-us">' + L.contact + '</a></div></aside>' : '') +
        '<div class="cp-pol__body rte"></div>' +
      '</div>' +
      '<nav class="cp-pol__more" aria-label="' + L.other + '"><p class="cp-eyebrow">' + L.more + '</p><ul role="list">' + rel + '</ul></nav>';
    wrap.querySelector('.cp-pol__title').textContent = title;
    var target = wrap.querySelector('.cp-pol__body');
    while (body.firstChild) target.appendChild(body.firstChild);
    box.innerHTML = '';
    box.appendChild(wrap);
    box.classList.add('cp-pol-ready');
    var toc = wrap.querySelector('.cp-pol__toc');
    if (toc && window.matchMedia('(max-width: 989px)').matches) toc.open = false;
    if (toc) toc.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ if (window.matchMedia('(max-width: 989px)').matches) toc.open = false; }); });
    if ('IntersectionObserver' in window && heads.length > 1) {
      var links = {};
      wrap.querySelectorAll('.cp-pol__list a').forEach(function(a){ links[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.isIntersecting) {
            Object.keys(links).forEach(function(k){ links[k].classList.toggle('is-current', k === e.target.id); });
          }
        });
      }, { rootMargin: '-15% 0px -70% 0px' });
      heads.forEach(function(h){ io.observe(h); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
